<template>
	<div class="page" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
		<!-- 头部页面位置标记 -->
		<el-breadcrumb>
			<el-breadcrumb-item>商品管理</el-breadcrumb-item>
			<el-breadcrumb-item>所有商品</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 头部页面位置标记  end -->

		<!-- 搜索模块 -->
		<div class="search-module">
			<el-row>
				<el-col :span="18">
					<el-form :inline="true" class="demo-form-inline">
						<el-form-item>
							<el-input v-model="filter.keyword" placeholder="搜索商品名称/商品编码" size="mini" clearable>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-select v-model="filter.slc_type " placeholder="请选择" value-key="label" size="mini"
								clearable>
								<el-option :value="1" label="体检商品"></el-option>
								<el-option :value="2" label="疫苗商品"></el-option>
								<el-option :value="3" label="自检商品"></el-option>
								<el-option :value="4" label="实物商品"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="onSearch" size="mini">查询</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="success" size="mini" @click="onRefresh">刷新</el-button>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="6" style="text-align: right;">
					<el-button type="primary" size="mini" icon="el-icon-circle-plus-outline" @click="onCreate">新增
					</el-button>
				</el-col>
			</el-row>
		</div>
		<!-- 搜索模块 end -->

		<!-- 商品状态分类模块 -->
		<el-tabs v-model="actTableType" type="card" @tab-click="changeTab">
			<el-tab-pane :label="'全部（' + counts.all + '）'" name="0"></el-tab-pane>
			<el-tab-pane :label="'已上架（' + counts.data_type1 + '）'" name="1"></el-tab-pane>
			<el-tab-pane :label="'已售罄（' + counts.data_type2 + '）'" name="2"></el-tab-pane>
			<el-tab-pane :label="'已下架（' + counts.data_type3 + '）'" name="3"></el-tab-pane>
			<el-tab-pane :label="'审核列表（' + unauditedNum + '）'" name="4"></el-tab-pane>
		</el-tabs>
		<!-- 商品状态分类模块 end -->

		<!-- 产品信息展示表格 -->
		<div class="table-module">
			<el-table v-loading="tableLoading" :data="tableData" border height="500"
				style="width: 100%; margin-bottom: 20px;" :header-cell-style="{background:'#F5F5F5'}">
				<el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
				<el-table-column prop="thumb" label="商品主图" align="center" width="100">
					<template slot-scope="scope">
						<div class="product-main-container">
							<el-image :src="scope.row.thumb ? scope.row.thumb : ''" style="width: 80px; height: 80px;"
								fit="contain"></el-image>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="商品信息" header-align="center" width="300">
					<template slot-scope="scope">
						<div class="product-info-container">
							<div>商品编号：{{ scope.row.good_no ? scope.row.good_no : '' }}</div>
							<div>{{ scope.row.title ? scope.row.title : '' }}</div>
							<div class="product-label-container">
								<div class="product-label-item">
									<el-tag class="tag" size="mini" effect="dark" v-for="(tag,i) in scope.row.tags"
										:key="i">
										{{ tag }}
									</el-tag>
								</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="sale_price" label="销售价格" align="center">
					<template slot-scope="scope">
						<div>
							<div>{{ scope.row.sale_price }}</div>
							<el-link v-if="(actTableType == 4 && scope.row.audit_status != 2) || actTableType != 4"
								type="primary" @click="handleUpdatePriceClick(scope.row)">修改价格</el-link>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="stock" label="库存" align="center">
					<template slot-scope="scope">
						<div>
							<div>{{ scope.row.stock ? scope.row.stock : '' }}</div>
							<el-link v-if="(actTableType == 4 && scope.row.audit_status != 2) || actTableType != 4"
								type="primary" @click="handleUpdateStockClick(scope.row)">修改库存</el-link>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="sales" label="总销量" align="center">
					<template slot-scope="scope">
						<div>
							<div>{{ scope.row.sales ? scope.row.sales : '' }}</div>
							<el-link v-if="(actTableType == 4 && scope.row.audit_status != 2) || actTableType != 4"
								type="primary" @click="handleUpdateSalesClick(scope.row)">修改数量</el-link>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="created_at" label="创建时间" align="center">
					<template slot-scope="scope">
						<div>
							<div>{{ scope.row.created_at ? scope.row.created_at : '' }}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="audit_status" label="审核状态" align="center">
					<template slot-scope="scope">
						<div>
							<el-tag :type="dict[(scope.row.audit_status)].type">
								{{dict[(scope.row.audit_status)].text}}
							</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="审核备注" align="center">
				</el-table-column>
				<el-table-column prop="status" label="上架状态" align="center">
					<template slot-scope="scope">
						<el-switch :disabled="actTableType == 0 && scope.row.audit_status == 1"
							v-model="scope.row.status" active-color="#0CC428" inactive-color="#F10019" :active-value="1"
							:inactive-value="0" @change="statusChange($event,scope.row.id)" v-if="actTableType != 4">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="180">
					<template slot-scope="scope">
						<el-button :disabled="(actTableType == 4 && scope.row.audit_status == 2) || scope.row.shop_store_apply_id == 0" size="mini"
							type="primary" @click="onEdit(scope.row)">编辑</el-button>
						<el-popconfirm v-if="scope.row.audit_status == 3" title="确定提交重审吗？"
							@confirm="handleRetrialClick(scope.row.id)">
							<el-button size="mini" type="primary" slot="reference">重审</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination background layout="prev,pager,next,total" :total="total" @current-change="pageChange"
				:current-page.sync="page" :page-size="15"></el-pagination>

			<el-dialog title="修改价格" :visible.sync="priceShow" width="30%" @close="resetInfo"
				:close-on-click-modal="false">
				<el-form :model="priceInfo" ref="info" :rules="rules" label-width="120px" :inline="false" size="small">
					<el-form-item label="价格" prop="sale_price">
						<el-input v-model="priceInfo.sale_price" style="width: 50%;"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer">
					<el-button @click="priceShow=false">取消</el-button>
					<el-button type="primary" @click="subPriceInfo">提交</el-button>
				</span>
			</el-dialog>

			<el-dialog title="修改库存" :visible.sync="stockShow" width="30%" @close="resetInfo"
				:close-on-click-modal="false">
				<el-form :model="stockInfo" ref="info" :rules="rules" label-width="120px" :inline="false" size="small">
					<el-form-item label="库存" prop="stock">
						<el-input v-model="stockInfo.stock" style="width: 50%;"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer">
					<el-button @click="stockShow=false">取消</el-button>
					<el-button type="primary" @click="subStockInfo">提交</el-button>
				</span>
			</el-dialog>

			<el-dialog title="修改销量" :visible.sync="saleShow" width="30%" @close="resetInfo"
				:close-on-click-modal="false">
				<el-form :model="salesInfo" ref="info" :rules="rules" label-width="100px" :inline="false" size="small">
					<el-form-item label="销量" prop="sales">
						<el-input v-model="salesInfo.sales" style="width: 50%;"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer">
					<el-button @click="saleShow=false">取消</el-button>
					<el-button type="primary" @click="subSalesInfo">提交</el-button>
				</span>
			</el-dialog>

			<el-dialog :title="dialogTitle" :visible.sync="infoShow" width="70%" @close="resetInfo"
				:close-on-click-modal="false">
				<el-form :model="info" ref="info" :rules="rules" label-width="120px" :inline="false" size="small"
					style="height: 450px;overflow-y:scroll;">
					<el-form-item label="商品分类" prop="good_cate_id" required>
						<!-- 						<el-select v-model="info.good_cate_id" placeholder="选择商品分类" style="width: 40%;" size="mini"
							filterable clearable>
							<el-option v-for="goodCate in goodCates" :key="goodCate.id" :label="goodCate.title"
								:value="goodCate.id">
							</el-option>
						</el-select> -->
						<el-cascader :options="goodCates" clearable
							:props="{checkStrictly: true, value: 'id', label: 'title'}" @change="handleCateChange">
						</el-cascader>
					</el-form-item>
					<el-form-item label="商品属性">
						<div class="flex">
							<el-form-item label="有无实物" prop="is_real">
								<el-switch v-model="info.is_real" :active-value="1" :inactive-value="0"></el-switch>
							</el-form-item>
							<el-form-item label="是否为自检产品" prop="is_self">
								<el-switch v-model="info.is_self" :active-value="1" :inactive-value="0"></el-switch>
							</el-form-item>
							<el-form-item label="是否需要预约" prop="need_visit">
								<el-switch v-model="info.need_visit" :active-value="1" :inactive-value="0"></el-switch>
							</el-form-item>
							<el-form-item label="是否为疫苗产品" prop="is_vaccine">
								<el-switch v-model="info.is_vaccine" :active-value="1" :inactive-value="0"
									@change="computeCost()">
								</el-switch>
							</el-form-item>
						</div>
						<div class="flex">
							<el-form-item label="附加项" prop="is_extend">
								<el-switch v-model="info.is_extend" :active-value="1" :inactive-value="0"></el-switch>
							</el-form-item>
							<el-form-item label="是否有vip卡" prop="is_vip">
								<el-switch v-model="info.is_vip" :active-value="1" :inactive-value="0"></el-switch>
							</el-form-item>
							<el-form-item label="多次消费长产品" prop="is_multiple">
								<el-switch v-model="info.is_multiple" :active-value="1" :inactive-value="0"></el-switch>
							</el-form-item>
						</div>
					</el-form-item>
					<!-- <el-form-item label="选择机构">
						<el-transfer v-model="shopsIds" :data="shops" :titles="['未选', '已选']" filterable
							@change="setInfoShops">
							<el-input placeholder="搜索机构" class="transfer-footer" slot="left-footer" size="mini"
								v-model="searchShopsTitle" style="width:50%;" clearable></el-input>
							<el-button class="transfer-footer" type="danger" slot="left-footer" size="mini"
								@click="getFilterShops">搜索
							</el-button>
							
						</el-transfer>
					</el-form-item> -->
					<el-form-item label="选择产品">
						<el-transfer v-model="productIds" :data="products" :titles="['未选', '已选']" filterable
							@change="setInfoProduct">
							<el-input placeholder="搜索产品" class="transfer-footer" slot="left-footer" size="mini"
								v-model="searchProductTitle" style="width:50%;" clearable></el-input>
							<el-button class="transfer-footer" type="danger" slot="left-footer" size="mini"
								@click="getFilterProdcuts">搜索
							</el-button>
							<!-- <el-button class="transfer-footer" type="success" slot="left-footer" size="mini"
								@click="clear">清除
							</el-button> -->
						</el-transfer>
					</el-form-item>
					<!-- <el-form-item label="商品编号" prop="good_no">
						<el-input v-model="info.good_no"></el-input>
					</el-form-item> -->
					<el-form-item label="商品描述">
						<div>
							<el-form-item label="商品名称" prop="title">
								<el-input v-model="info.title" style="width: 60%;"></el-input>
							</el-form-item>
							<el-form-item label="落地名称" prop="small_title">
								<el-input v-model="info.small_title" style="width: 60%;"></el-input>
							</el-form-item>
							<el-form-item label="商品标签" required>
								<el-input v-model="commodityLabel" style="width: 100px; margin-right: 10px;"></el-input>
								<el-button type="primary" size="mini" @click="handleAddLabelClick">添加</el-button>
							</el-form-item>
							<el-form-item label="当前标签:">
								<el-tag v-for="(item, index) in labelList" :key="index" :closable="true" type="info"
									effect="plain" style="margin-right: 10px;" @close="handleDeleteLabelClick(index)">
									{{ item }}
								</el-tag>
							</el-form-item>
						</div>
					</el-form-item>
					<el-form-item label="商品价格">
						<div class="flex">
							<div>
								<el-form-item label="男成本价" prop="cost_price_man">
									<el-input v-model="info.cost_price_man"></el-input>
								</el-form-item>
								<el-form-item label="女未婚成本价" prop="cost_price_female_unmarried">
									<el-input v-model="info.cost_price_female_unmarried"></el-input>
								</el-form-item>
								<el-form-item label="女已婚成本价" prop="cost_price_female_married">
									<el-input v-model="info.cost_price_female_married"></el-input>
								</el-form-item>
							</div>
							<div>
								<el-form-item label="原价" prop="original_price">
									<el-input v-model="info.original_price"></el-input>
								</el-form-item>
								<el-form-item label="指导价" prop="guide_price">
									<el-input v-model="info.guide_price"></el-input>
								</el-form-item>
								<el-form-item label="售价" prop="sale_price">
									<el-input v-model="info.sale_price" @blur="computeCost()"></el-input>
								</el-form-item>
							</div>
						</div>
						<div class="flex">
							<el-form-item label="活动价" prop="active_price">
								<el-input v-model="info.active_price"></el-input>
							</el-form-item>
							<el-form-item label="大促价" prop="year_end_price">
								<el-input v-model="info.year_end_price"></el-input>
							</el-form-item>
						</div>
						<div class="flex">
							<div>
								<el-form-item label="VIP代理商价格" prop="vip_agent_price">
									<el-input v-model="info.vip_agent_price"></el-input>
								</el-form-item>
								<el-form-item label="铂金代理商价格" prop="pt_agent_price">
									<el-input v-model="info.pt_agent_price"></el-input>
								</el-form-item>
								<el-form-item label="钻石代理商价格" prop="do_agent_price">
									<el-input v-model="info.do_agent_price"></el-input>
								</el-form-item>
							</div>
							<div>
								<el-form-item label="3星分销商价格" prop="three_stars_price">
									<el-input v-model="info.three_stars_price"></el-input>
								</el-form-item>
								<el-form-item label="4星分销商价格" prop="four_stars_price">
									<el-input v-model="info.four_stars_price"></el-input>
								</el-form-item>
								<el-form-item label="5星分销商价格" prop="five_stars_price">
									<el-input v-model="info.five_stars_price"></el-input>
								</el-form-item>
							</div>
						</div>
						<el-divider></el-divider>
						<div class="flex">
							<el-form-item label="库存" prop="stock">
								<el-input v-model="info.stock"></el-input>
							</el-form-item>
							<el-form-item label="销量" prop="sales">
								<el-input v-model="info.sales"></el-input>
							</el-form-item>
						</div>
					</el-form-item>
					<el-form-item label="主图区">
						<div class="flex">
							<div>
								<el-upload :action="uploadUrl" ref="mainPicture" list-type="picture-card" :limit="1"
									:on-success="uploadSuccess" :fileList="mainPicture">
									<!-- <img class="uploadimg" v-if="info.thumb" :src="info.thumb"> -->
									<i class="el-icon-plus avatar-uploader-icon"></i>
									<div slot="tip" class="el-upload__tip">主图</div>
								</el-upload>
							</div>
							<div class="uploadBanner">
								<el-upload :action="uploadUrl" multiple :limit="5" list-type="picture-card"
									:on-success="uploadAlbumSuccess" :file-list="currentAlbum" :on-remove="albumRemove">
									<i class="el-icon-plus img-uploader-icon"></i>
									<div slot="tip" class="el-upload__tip">轮播图</div>
								</el-upload>
							</div>
						</div>
						<div class="tip">
							图片至少上传1张（第一张不计图片空间容量），图片类型只能为png、jpg、jpeg，且大小不超过500K，800*800像素以上的图片<br />
							请不要在商品图片上添加除商品外的其他信息，如水印、优惠信息等，一经发现降权处理。<br />
							请注意图片版权，商家若不当使用他人权利，将被删除商品及扣分处理。<br />
						</div>
					</el-form-item>
					<el-form-item label="商品详情">
						<quill-editor v-model="info.detail" ref="myQuillEditor" :options="editorOption"></quill-editor>
					</el-form-item>
				</el-form>

				<span slot="footer">
					<el-button @click="closeGoodInfoDialog">取消</el-button>
					<el-button type="primary" @click="subInfo">提交</el-button>
				</span>
			</el-dialog>
		</div>
		<!-- 产品信息展示表格 end -->
	</div>
</template>

<script>
	import {
		quillEditor
	} from 'vue-quill-editor'
	import {
		quillRedefine
	} from 'vue-quill-editor-upload'
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	export default {
		components: {
			quillEditor
		},

		name: 'AllCommodity',
		data() {
			return {
				loading: true,
				tableLoading: false,
				mainPicture: [],
				dict: {
					1:{
						text: '待审核',
						type: ''
					},
					2:{
						text: '审核成功',
						type: 'success'
					},
					0:{
						text: '无需审核',
						type: 'success'
					}
				},
				unauditedNum: 0,
				filter: {
					page: 1,
					keyword: '',
					slc_type: '',
					data_type: '',
				},
				actTableType: '0',
				tableData: [],
				counts: {},
				page: 1,
				maxpage: 1,
				total: 0,
				priceInfo: {
					id: '',
					sale_price: '',
				},
				priceShow: false,
				stockInfo: {
					id: '',
					stock: '',
				},
				stockShow: false,
				salesInfo: {
					id: '',
					sales: '',
				},
				saleShow: false,
				info: {
					title: '',
					small_title: '',
					good_cate_id: '',
					cost_price_man: '',
					cost_price_female_unmarried: '',
					cost_price_female_married: '',
					original_price: '',
					guide_price: '',
					sale_price: '',
					active_price: '',
					year_end_price: '',
					vip_agent_price: '',
					pt_agent_price: '',
					do_agent_price: '',
					three_stars_price: '',
					four_stars_price: '',
					five_stars_price: '',
					stock: '',
					sales: '',
					tags: '',
					is_real: 0,
					is_self: 0,
					need_visit: 0,
					is_vaccine: 0,
					is_extend: 0,
					is_vip: 0,
					is_multiple: 0,
					detail: '',
				},
				rules: {
					title: [{
						required: true,
						message: '请填写商品名称',
						trigger: 'blur'
					}],
					small_title: [{
						required: true,
						message: '请填写落地名称',
						trigger: 'blur'
					}],
					original_price: [{
						required: true,
						message: '请填写原价',
						trigger: 'blur'
					}],
					guide_price: [{
						required: true,
						message: '请填写指导价',
						trigger: 'blur'
					}],
					sale_price: [{
						required: true,
						message: '请填写售价',
						trigger: 'blur'
					}],
					cost_price_man: [{
						required: true,
						message: '请填写男成本价',
						trigger: 'blur'
					}],
					cost_price_female_unmarried: [{
						required: true,
						message: '请填写女未婚成本价',
						trigger: 'blur'
					}],
					cost_price_female_married: [{
						required: true,
						message: '请填写女已婚成本价',
						trigger: 'blur'
					}],
				},
				infoShow: false,
				dialogTitle: '',
				saveType: 1,
				searchProductTitle: '',
				searchShopsTitle: '',
				goodCates: [],
				commodityLabel: '',
				labelList: [],
				shopsIds: [],
				shops: [],
				productIds: [],
				products: [],
				uploadUrl: this.$util.host + '/seller/upload',
				currentAlbum: [],
				currentAlbum1: [],
				status: [],
				editorOption: {},
			}
		},
		created() {
			this.getUnauditedNum().then(num => this.unauditedNum = num);
			this.getGoodsInfo(this.filter).then(goodsInfo => {
				this.total = goodsInfo.total;
				this.counts = goodsInfo.counts;
				this.tableData = goodsInfo.data;
				this.loading = false;
			})
			this.getGoodClassifications().then(res => this.goodCates = res);
			this.editorOption = quillRedefine({
				// 图片上传的设置
				uploadConfig: {
					action: this.uploadUrl, // 必填参数 图片上传地址
					// 必选参数  res是一个函数，函数接收的response为上传成功时服务器返回的数据
					// 你必须把返回的数据中所包含的图片地址 return 回去
					res: (respnse) => {
						return respnse.data // 这里切记要return回你的图片地址
					},
					name: 'file'
				}
			})
		},
		methods: {
			handleCateChange(e) {
				const index = e.length - 1;
				this.info.good_cate_id = e[index];
				console.log('this info', this.info.good_cate_id);
				console.log('e', e);
			},
			updateGoodOnShelf(newGoodInfo) {
				this.$util.put('merchant/good/goods/' + newGoodInfo.id, newGoodInfo).then(res => {
					const code = res.code;

					if (code && code !== 0) {
						const msg = res.msg;
						this.$message.warning(msg);
					} else {
						this.infoShow = false;

						this.$message.success('操作成功');
						this.getGoodsInfo(this.filter).then(goodsInfo => {
							this.tableData = goodsInfo.data;
							this.tableLoading = false;
						})
					}
				})
			},
			updateUnauditedGood(newGoodInfo) {
				this.$util.put('merchant/good/applyGood/' + newGoodInfo.id, newGoodInfo).then(res => {
					const code = res.code;

					if (code && code !== 0) {
						const msg = res.msg;
						this.$message.warning(msg);
					} else {
						this.infoShow = false;

						this.$message.success('操作成功');
						this.getUnauditedGoods(this.filter).then(res => this.tableData = res);
					}
				})
			},
			async getUnauditedNum() {
				const num = await this.$util.get('merchant/good/applyGood', {}).then(res => {
					const total = res.total;
					return total;
				})
				return num;
			},
			async getGoodsInfo(filter) {
				const goodsInfo = await this.$util.get('merchant/good/goods', filter).then(res => res);
				return goodsInfo;
			},
			async getUnauditedGoods(filter) {
				const unauditedGoods = await this.$util.get('merchant/good/applyGood', filter).then(res => {
					const resData = res.data || [];
					this.total = res.total || 0;
					this.unauditedNum = res.total;
					this.tableLoading = false;
					this.loading = false;
					return resData;
				})
				return unauditedGoods;
			},
			getData() {
				this.loading = true
				let data = this.filter
				data.page = this.page
				this.tableData = []
				if (this.actTableType == 4) {
					this.getUnauditedGoods(this.filter).then(res => this.tableData = res);
				} else {
					this.$util.get('merchant/good/goods', data)
						.then(res => {
							this.loading = false
							this.tableData = res.data
							this.total = res.total
							this.counts = res.counts
							for (let i = 0; i < res.data.length; i++) {
								if (typeof res.data[i].tags == "string") {
									if (res.data[i].tags && res.data[i].tags.length > 0) {
										this.tableData[i].tags = this.tableData[i].tags.split(',')
									} else {
										this.tableData[i].tags = []
									}
									if (this.tableData[i].status == 1) {
										this.status[i] = true
									} else {
										this.status[i] = false
									}
								}
							}
						})
				}
			},
			// 搜索按钮
			onSearch() {
				this.tableData = [];
				this.page = 1;
				this.maxpage = 1;
				this.total = 0;
				this.getData()
			},
			// 刷新按钮
			onRefresh() {
				this.getData()
			},
			pageChange(page) {
				this.tableData = []
				this.page = page
				this.getData()
			},
			// 新增按钮
			onCreate() {
				this.saveType = 1
				this.dialogTitle = "新增商品"
				this.infoShow = true
				// this.getGoodCates()
				this.labelList = [];
				this.currentAlbum = [];
				this.currentAlbum1 = [];
				this.searchProductTitle = '';
				this.searchShopsTitle = '';
				this.shopsIds = [];
				this.shops = [];
				this.products = [];
				this.productIds = [];
				this.commodityLabel = '';
			},
			// 商品状态tab改变
			changeTab(tab) {
				const tabIndex = tab.name;
				this.tableLoading = true;
				this.page = 1;
				this.filter.page = this.page;
				this.tableData = [];

				if (tabIndex == 0 || tabIndex == 4) this.filter.data_type = '';
				else this.filter.data_type = tabIndex;

				if (tabIndex == 4) {
					this.getUnauditedGoods(this.filter).then(res => this.tableData = res);
				} else {
					this.getGoodsInfo(this.filter).then(goodsInfo => {
						this.total = goodsInfo.total;
						this.tableData = goodsInfo.data;
						this.tableLoading = false;
					})
				}
			},
			// 修改价格点击
			handleUpdatePriceClick(row) {
				this.priceShow = true;

				if (this.actTableType == 4) {
					this.priceInfo = {
						id: row.id,
						sale_price: row.sale_price
					}
				} else {
					this.setInfoObj(row);
				}
			},
			subPriceInfo() {
				if (isNaN(this.priceInfo.sale_price) || !this.priceInfo.sale_price) {
					this.$message.warning('请输入数字');
				} else {
					if (this.actTableType == 4) {
						this.$util.put('merchant/good/applyGood/quick/' + this.priceInfo.id, {
								field: 'sale_price',
								value: this.priceInfo.sale_price
							})
							.then(res => {
								if (res.code == 0) {
									this.priceShow = false
									this.getData()
								} else {
									this.$message(res.msg)
								}
							})
					} else {
						this.info.sale_price = this.priceInfo.sale_price;
						const goodInfo = this.getGoodInfoOnshelf();
						this.updateGoodOnShelf(goodInfo);
						this.addAuditGood(this.info);
					}
				}
			},
			// 修改库存点击
			handleUpdateStockClick(row) {
				this.stockShow = true;

				if (this.actTableType == 4) {
					this.stockInfo = {
						id: row.id,
						stock: row.stock
					}
				} else {
					this.setInfoObj(row);
				}

			},
			subStockInfo() {
				if (isNaN(this.stockInfo.stock) || !this.stockInfo.stock) {
					this.$message.warning('请输入数字');
				} else {
					if (this.actTableType == 4) {
						this.$util.put('merchant/good/applyGood/quick/' + this.stockInfo.id, {
								field: 'stock',
								value: this.stockInfo.stock
							})
							.then(res => {
								if (res.code == 0) {
									this.stockShow = false
									this.getData()
								} else {
									this.$message(res.msg)
								}
							})
					} else {
						this.info.stock = this.stockInfo.stock;
						const goodInfo = this.getGoodInfoOnshelf();
						this.updateGoodOnShelf(goodInfo);
						this.addAuditGood(this.info);
					}
				}
			},
			// 修改销量点击
			handleUpdateSalesClick(row) {
				this.saleShow = true;

				if (this.actTableType == '4') {
					this.salesInfo = {
						id: row.id,
						sales: row.sales
					}
				} else {
					this.setInfoObj(row);
				}
			},
			subSalesInfo() {
				if (isNaN(this.salesInfo.sales) || !this.salesInfo.sales) {
					this.$message.warning('请输入数字');
				} else {
					if (this.actTableType == 4) {
						this.$util.put('merchant/good/applyGood/quick/' + this.salesInfo.id, {
								field: 'sales',
								value: this.salesInfo.sales
							})
							.then(res => {
								if (res.code == 0) {
									this.saleShow = false
									this.getData()
								} else {
									this.$message(res.msg)
								}
							})
					} else {
						this.info.sales = this.salesInfo.sales;
						const goodInfo = this.getGoodInfoOnshelf();

						this.updateGoodOnShelf(goodInfo);
						this.addAuditGood(this.info);
					}
				}
			},
			statusChange($event, id) {
				this.tableLoading = true;

				this.$util.put('merchant/good/goods/quick/' + id, {
						field: 'status',
						value: $event
					})
					.then(res => {
						if (res.code == 0) {
							this.getGoodsInfo(this.filter).then(goodsInfo => {
								this.counts = goodsInfo.counts;
								this.total = goodsInfo.total;
								this.tableData = goodsInfo.data;
								this.tableLoading = false;
							})
						} else {
							this.$message(res.msg)
						}
					})
			},
			resetInfo() {
				this.$refs.mainPicture.clearFiles();

				this.priceInfo = {
					sale_price: '',
				}
				this.stockInfo = {
					stock: '',
				}
				this.salesInfo = {
					sales: '',
				}
				this.info = {
					title: '',
					small_title: '',
					good_cate_id: '',
					cost_price_man: '',
					cost_price_female_unmarried: '',
					cost_price_female_married: '',
					original_price: '',
					guide_price: '',
					sale_price: '',
					active_price: '',
					year_end_price: '',
					vip_agent_price: '',
					pt_agent_price: '',
					do_agent_price: '',
					three_stars_price: '',
					four_stars_price: '',
					five_stars_price: '',
					stock: '',
					sales: '',
					tags: '',
					is_real: 0,
					is_self: 0,
					need_visit: 0,
					is_vaccine: 0,
					is_extend: 0,
					is_vip: 0,
					is_multiple: 0,
					thumb: '',
					detail: '',
				}
				this.priceShow = false;
				this.stockShow = false;
				this.saleShow = false;
				this.infoShow = false;
				this.labelList = [];
				this.currentAlbum = [];
				this.currentAlbum1 = [];
				this.shopsIds = [];
				this.shops = [];
				this.products = [];
				this.productIds = [];
				this.searchProductTitle = '';
				this.searchShopsTitle = '';
				this.commodityLabel = '';
			},
			// 设置主图
			setMainPicture(url) {
				const item = {
					url,
				}
				this.mainPicture.splice(0, 1);
				this.mainPicture.push(item);
			},
			setProducts(products) {
				this.productIds = [];
				this.products = products.map(item => {
					this.productIds.push(item.id);
					return {
						key: item.id,
						label: item.purchase_title
					}
				})
			},
			setInfoObj(row) {
				this.info = {
					good_cate_id: row.good_cate_id,
					title: row.title,
					small_title: row.small_title,
					thumb: row.thumb,
					cost_price: row.cost_price,
					original_price: row.original_price,
					guide_price: row.guide_price,
					sale_price: row.sale_price,
					cost_price_man: row.cost_price_man,
					cost_price_female_married: row.cost_price_female_married,
					cost_price_female_unmarried: row.cost_price_female_unmarried,
					is_real: row.is_real,
					is_self: row.is_self,
					need_visit: row.need_visit,
					is_extend: row.is_extend,
					is_multiple: row.is_multiple,
					multiple_dates: row.multiple_dates,
					is_vip: row.is_vip,
					is_vaccine: row.is_vaccine,
					album: row.album ? [...row.album] : [],
					vip_agent_price: row.vip_agent_price,
					pt_agent_price: row.pt_agent_price,
					do_agent_price: row.do_agent_price,
					three_stars_price: row.three_stars_price,
					four_stars_price: row.four_stars_price,
					five_stars_price: row.five_stars_price,
					stock: row.stock,
					sales: row.sales,
					detail: row.detail,
					// detail_imgs: row.detail_imgs ? [...row.detail_imgs] : [],
				}
				this.setProducts(row.products);
				this.info.productIds = this.productIds;

				if (this.actTableType != 4) this.info.good_id = row.id;
				else this.info.id = row.id;
			},
			// 编辑按钮
			onEdit(row) {
				this.searchProductTitle = '';
				this.commodityLabel = '';
				this.saveType = 2
				this.dialogTitle = "编辑商品"
				// this.getGoodCates();
				if (row.tags && row.tags.length > 0) {
					this.labelList = row.tags
				} else {
					this.labelList = []
				}
				this.setMainPicture(row.thumb);
				this.setInfoObj(row);

				if (row.album && row.album.length > 0) {
					row.album.forEach(album => {
						this.currentAlbum.push({
							url: album
						})
					});
				}
				// if (row.detail_imgs && row.detail_imgs.length > 0) {
				// 	if (row.detail_imgs[0] && row.detail_imgs[0].length > 0) {
				// 		row.detail_imgs[0].forEach(picture => {
				// 			this.picture.push({
				// 				url: picture
				// 			})
				// 			this.picture1.push(picture)
				// 		})
				// 	} else {
				// 		this.picture = []
				// 		this.picture1 = []
				// 	}
				// 	if (row.detail_imgs[1] && row.detail_imgs[1].length > 0) {
				// 		row.detail_imgs[1].forEach(detail => {
				// 			this.detail.push({
				// 				url: detail
				// 			})
				// 			this.detail1.push(detail)
				// 		})
				// 	} else {
				// 		this.detail = []
				// 		this.detail1 = []
				// 	}
				// 	if (row.detail_imgs[2] && row.detail_imgs[2].length > 0) {
				// 		row.detail_imgs[2].forEach(introduce => {
				// 			this.introduce.push({
				// 				url: introduce
				// 			})
				// 			this.introduce1.push(introduce)
				// 		})
				// 	} else {
				// 		this.introduce = []
				// 		this.introduce1 = []
				// 	}
				// 	if (row.detail_imgs[3] && row.detail_imgs[3].length > 0) {
				// 		row.detail_imgs[3].forEach(notice => {
				// 			this.notice.push({
				// 				url: notice
				// 			})
				// 			this.notice1.push(notice)
				// 		})
				// 	} else {
				// 		this.notice = []
				// 		this.notice1 = []
				// 	}
				// }
				this.infoShow = true
			},
			getGoodCates() {
				this.$util.post('merchant/slc', {
					model: 'GoodCate'
				}).then(res => {
					this.goodCates = res.data
				})
			},
			async getGoodClassifications() {
				const classifications = await this.$util.get('merchant/good_cate', {}).then(res => res);
				return classifications;
			},
			computeCost() {
				if (this.info.is_vaccine == 1) {
					let cost = (parseFloat(this.info.sale_price) * 0.9).toFixed(2)
					this.info.cost_price_man = cost
					this.info.cost_price_female_unmarried = cost
					this.info.cost_price_female_married = cost
				}
			},
			// 删除标签按钮
			handleDeleteLabelClick(index) {
				this.labelList.splice(index, 1);
			},
			// 添加标签按钮
			handleAddLabelClick() {
				// 商品标签不为真
				if (!this.commodityLabel) {
					this.$message.warning('请输入标签后再添加')
				} else {
					// 当前标签是否已存在
					const isTrue = this.labelList.indexOf(this.commodityLabel) !== -1;
					if (isTrue) {
						this.$message.warning('该标签已添加过了');
					} else {
						this.labelList.push(this.commodityLabel);
						this.$message('添加成功');
						this.commodityLabel = '';
					}
				}
			},
			getProducts() {
				if (this.searchProductTitle == '' && this.productIds.length <= 0) {
					return false;
				}
				this.$util.post('merchant/slc', {
					model: 'Product',
					keyword: this.searchProductTitle,
					ids: this.productIds
				}).then(res => {
					let data = res.data ? res.data : res
					data.forEach(product => {
						let hasSame = 0;
						this.products.forEach(item => {
							if (item.key == product.id) {
								hasSame = 1
							}
						})
						if (hasSame == 0) {
							this.products.push({
								key: product.id,
								label: product.managing_title ? product.managing_title : product
									.purchase_title,
							})
						}
					})
				})
			},
			setInfoProduct() {
				this.info.productIds = this.productIds
			},
			setInfoShops() {
				this.info.shopsIds = this.shopsIds
			},
			getFilterProdcuts() {
				if (!this.searchProductTitle) {
					this.$message.error('请输入关键词搜索可选产品')
				}
				this.getProducts()
			},
			getFilterShops() {
				if (!this.searchShopsTitle) {
					this.$message.error('请输入关键词搜索可选门店')
				}
			},
			clear() {
				this.products = [];
				this.searchProductTitle = ""
			},
			closeGoodInfoDialog() {
				this.$refs.mainPicture.clearFiles();
				this.infoShow = false;
			},
			addAuditGood(goodInfo) {
				this.$util.post('merchant/good/applyGood', goodInfo).then(res => {
					const code = res.code;

					if (code === 0) {
						this.infoShow = false;
						this.priceShow = false;
						this.stockShow = false;
						this.saleShow = false;
						this.actTableType = '4';

						this.$message.success('提交成功，信息已添加到审核列表');
						this.getUnauditedGoods(this.filter)
							.then(res => {
								this.tableData = res;
							})
					} else {
						const msg = res.msg;
						this.$message.warning(msg);
					}
				})
			},
			getGoodInfoOnshelf() {
				const goodInfo = Object.assign({}, this.info);
				goodInfo.id = this.info.good_id;
				delete goodInfo.good_id;

				return goodInfo;
			},
			subInfo() {
				this.$refs['info'].validate((valid) => {
					if (valid) {
						if (!this.info.cost_price && this.info.cost_price_man) {
							this.info.cost_price = this.info.cost_price_man
						}
						this.info.tags = this.labelList;
						this.info.album = []
						this.currentAlbum1.forEach(file => {
							if (file.response && file.response.data) {
								this.info.album.push(file.response.data)
							} else if (file.url) {
								this.info.album.push(file.url)
							}
						})
						// this.info.detail_imgs = [this.picture1, this.detail1, this.introduce1, this.notice1];

						if (this.saveType == 1) {
							this.addAuditGood(this.info);
						} else if (this.actTableType == 4) {
							this.tableLoading = true;
							this.updateUnauditedGood(this.info);
						} else {
							const goodInfo = this.getGoodInfoOnshelf();

							this.updateGoodOnShelf(goodInfo);
							this.addAuditGood(this.info);
						}
						this.labelList = [];
						this.currentAlbum1 = [];
					}
				})
			},
			uploadSuccess(res) {
				this.info.thumb = res.data
			},
			uploadAlbumSuccess(res) {
				this.currentAlbum1.push({
					url: res.data
				})
			},
			albumRemove(file, fileList) {
				this.info.album = []
				fileList.forEach(item => {
					this.currentAlbum1.push({
						url: item.data
					})
				});
			},
			retrial(data) {
				this.$util.get('merchant/good/reApply', data).then(msg => {
					this.$message.success(msg);
					this.getUnauditedGoods(this.filter).then(res => this.tableData = res);
				})
			},
			handleRetrialClick(id) {
				const params = {
					id,
					audit_status: 1,
				}
				this.retrial(params)
			},
		}
	}
</script>

<style lang="less" scoped>
	.search-module {
		margin-top: 20px;
	}

	.highlight-text {
		cursor: pointer;
		color: #4A94EB;
	}

	.info,
	.success {
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #007CFF;
	}

	.success {
		color: #0CC428;
	}

	.table-module {
		/* margin-top: 2px; */
		width: 100%;
		max-width: 100%;
	}

	.product-info-container {
		.product-label-container {
			display: flex;
			flex-wrap: wrap;

			.product-label-item {
				margin-right: 5px;
				margin-top: 5px;

				.tag {
					margin-right: 10px;
				}
			}
		}
	}

	.product-main-container {
		height: 80px;
		width: 80px;
		text-align: center;
	}

	/deep/ .el-tabs__header {
		margin: 0px;
	}

	/deep/ .el-tabs--card>.el-tabs__header,
	.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
		border-bottom: none;
	}

	/deep/ .el-tabs__item {
		background-color: #F3F3F3;
		width: 180px;
		text-align: center;
		height: 48px;
		line-height: 48px;
	}

	/deep/ .el-tabs__item.is-active {
		background-color: transparent;
		color: #333333;
	}

	.flex {
		display: flex;
	}

	/deep/ .el-transfer-panel {
		width: 300px;
	}

	.transfer-footer {
		margin-left: 10px;
	}

	.uploadBanner {
		margin-left: 100px;
	}

	.uploadimg {
		height: 148px;
		width: 148px;
	}

	.tip {
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #AAAAAA;
		padding-top: 10px;
	}

	.detail {
		margin-top: 10px;
	}

	.quill-editor {
		width: 80%;
	}

	.quill-editor /deep/ .ql-container {
		min-height: 300px;
	}
</style>
